export function defaultRoomUrlForEnvironment(deployments, environmentKey) {
  if (!Array.isArray(deployments)) {
    return null;
  }

  const deployment = deployments.find(
    candidate => candidate?.environmentKey === environmentKey && candidate?.targetKey === "room"
  );
  const url = deployment?.default_room?.url;

  return typeof url === "string" && url.trim().length > 0 ? url : null;
}
